import { PropertyHeadingEnum } from "./property-heading.model";
// @ts-ignore
export const headingToPropertyAttributeLookup = new Map([
    [PropertyHeadingEnum.Address, "address"],
    [PropertyHeadingEnum.ErfNumber, "erfNumber"],
    [PropertyHeadingEnum.SGCode, "sgCode"],
    [PropertyHeadingEnum.FarmNumber, "farmNumber"],
    [PropertyHeadingEnum.Allotment, "allotment"],
    [PropertyHeadingEnum.PropertyDescription, "propertyDescription"],
    [PropertyHeadingEnum.PtnNumber, "ptnNum"]
]);
export const headingToSectionalTitleAttributeLookup = new Map([
    [PropertyHeadingEnum.Address, "address"],
    [PropertyHeadingEnum.ErfNumber, "erfNumber"],
    [PropertyHeadingEnum.SGCode, "sgCode"],
    [PropertyHeadingEnum.FarmNumber, "farmNumber"],
    [PropertyHeadingEnum.Allotment, "allotment"],
    [PropertyHeadingEnum.PropertyDescription, "propertyDescription"],
    [PropertyHeadingEnum.PtnNumber, "ptnNum"],
    [PropertyHeadingEnum.SectionalTitleID, "sectionalTitleId"],
    [PropertyHeadingEnum.UnitNumber, "unitNumber"]
]);
export const headingToOwnerAttributeLookup = new Map([
    [PropertyHeadingEnum.Address, "address"],
    [PropertyHeadingEnum.ErfNumber, "erfNumber"],
    [PropertyHeadingEnum.SGCode, "sgCode"],
    [PropertyHeadingEnum.OwnerName, "name"],
    [PropertyHeadingEnum.OwnerSurname, "surname"],
    [PropertyHeadingEnum.OwnerIDNumber, "idNumber"],
    [PropertyHeadingEnum.OwnerOrganisation, "organisation"],
    [PropertyHeadingEnum.OwnerOrganisationRegNo, "organisationRegistrationNumber"],
    [PropertyHeadingEnum.OwnerRepresentative, "representative"],
]);
export const headingToZoningAttributeLookup = new Map([
    [PropertyHeadingEnum.Address, "address"],
    [PropertyHeadingEnum.ErfNumber, "erfNumber"],
    [PropertyHeadingEnum.SGCode, "sgCode"],
    [PropertyHeadingEnum.FarmNumber, "farmNumber"],
    [PropertyHeadingEnum.Allotment, "allotment"],
    [PropertyHeadingEnum.Zoning, "zoning"]
]);
export const headingToCemeteryGraveAttributeLookup = new Map([
    [PropertyHeadingEnum.Cemetery, "cemetery"],
    [PropertyHeadingEnum.PlotNumber, "plotNumber"],
    [PropertyHeadingEnum.GraveID, "graveId"],
    [PropertyHeadingEnum.GraveStatus, "graveStatus"],
    [PropertyHeadingEnum.Capacity, "capacity"],
    [PropertyHeadingEnum.MarkerType, "markerType"],
    [PropertyHeadingEnum.Condition, "condition"],
]);
